import React from 'react';
import _ from 'underscore';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import * as Headers from 'ui-library/Headers';
import ChipSelectInput from 'ui-library/inputs/ChipSelectInput';
import {OptionValue} from 'ui-library/menus/MenuConstants';
import {getMatchingOptionDatas} from 'ui-library/menus/MenuUtil';
import {InputChangeEvent} from 'util/Types';

interface SelectInputGuidelinesState {
  query: string;
  value: Array<string>;
}

export default class SelectInputGuidelines extends React.Component<{}, SelectInputGuidelinesState> {
  state: SelectInputGuidelinesState = {
    query: '',
    value: ['read-is-write', 'mta-team'],
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleQueryChange = (e: InputChangeEvent) => {
    this.setState({query: e.target.value});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleSelectOption = (value: OptionValue) => {
    notifications.success(`You selected ${value}!`);
    this.setState({query: ''});
    if (this.state.value.includes(value)) {
      // eslint-disable-next-line no-restricted-syntax
      this.setState({value: _.without(this.state.value, value)});
    } else {
      this.setState({value: [...this.state.value, value]});
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleRemoveOption = (value: OptionValue) => {
    // eslint-disable-next-line no-restricted-syntax
    this.setState({value: _.without(this.state.value, value)});
  };

  render(): JSX.Element {
    return (
      <div className="u-spacing">
        <Headers.Header1>Select Inputs</Headers.Header1>
        <div>
          <a href="https://projects.invisionapp.com/d/main/default/#/console/13433387/283355069/preview">
            https:// projects.invisionapp.com/d/main/default/#/console/13433387/283355069/preview
          </a>
        </div>
        <div>
          <code>ui-library/inputs/ChipSelectInput.tsx</code>
        </div>
        <Row>
          <Col xs={6}>
            <div className="u-spacing-bottom">
              <Headers.Sublabel>Multi-Select Input</Headers.Sublabel>
              <p>Which teams like spint'gls?</p>
              <ChipSelectInput
                optionDatas={getMatchingOptionDatas(this.state.query, [
                  {name: 'read-is-write', value: 'read-is-write', icon: 'edit'},
                  {name: 'mad-scientists', value: 'mad-scientists', icon: ModelTypeConstants.BATCH},
                  {name: 'mta-team', value: 'mta-team', icon: 'users'},
                  {name: 'team-werk', value: 'team-werk', icon: 'workflow'},
                  {name: 'team-resultants', value: 'team-resultants', icon: 'table'},
                ])}
                onQueryChange={this._handleQueryChange}
                onRemove={this._handleRemoveOption}
                onSelect={this._handleSelectOption}
                placeholder="Type something..."
                query={this.state.query}
                value={this.state.value}
                isMulti={true}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
